import React, { useState } from 'react';

const MonthlyGoal = ({ 
  currentGoal, 
  currentProfit, 
  nextMonthBudget, 
  onGoalUpdate, 
  onDistributionUpdate 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [newGoal, setNewGoal] = useState(currentGoal);
  const [newDistribution, setNewDistribution] = useState(nextMonthBudget.distribution || 0);
  
  // Calcular progresso da meta
  const progress = (currentProfit / currentGoal) * 100;
  const isAchieved = progress >= 100;
  
  // Função para iniciar edição
  const startEditing = () => {
    setNewGoal(currentGoal);
    setIsEditing(true);
  };
  
  // Função para salvar alterações
  const saveChanges = () => {
    onGoalUpdate(parseFloat(newGoal));
    onDistributionUpdate(parseFloat(newDistribution));
    setIsEditing(false);
  };
  
  // Função para cancelar edição
  const cancelEditing = () => {
    setNewGoal(currentGoal);
    setNewDistribution(nextMonthBudget.distribution || 0);
    setIsEditing(false);
  };
  
  return (
    <div className="monthly-goal-card">
      <div className="monthly-goal-header">
        <h3>Meta de Lucro Mensal</h3>
        
        {!isEditing ? (
          <button className="btn-edit-goal" onClick={startEditing}>
            ✏️ Editar
          </button>
        ) : (
          <div className="edit-actions">
            <button className="btn-save" onClick={saveChanges}>
              💾 Salvar
            </button>
            <button className="btn-cancel" onClick={cancelEditing}>
              ❌ Cancelar
            </button>
          </div>
        )}
      </div>
      
      {isEditing ? (
        <div className="goal-edit-form">
          <div className="form-row">
            <div className="form-group">
              <label>Meta de Lucro (R$)</label>
              <input
                type="number"
                value={newGoal}
                onChange={(e) => setNewGoal(e.target.value)}
                min="0"
                step="100"
              />
            </div>
            
            <div className="form-group">
              <label>Distribuição para o Próximo Mês (R$)</label>
              <input
                type="number"
                value={newDistribution}
                onChange={(e) => setNewDistribution(e.target.value)}
                min="0"
                step="100"
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="goal-progress">
            <div className="progress-info">
              <span className="current-value">R$ {currentProfit.toFixed(2)}</span>
              <span className="goal-value">Meta: R$ {currentGoal.toFixed(2)}</span>
            </div>
            
            <div className="progress-bar-container">
              <div 
                className={`progress-bar ${isAchieved ? 'complete' : ''}`}
                style={{ width: `${Math.min(progress, 100)}%` }}
              ></div>
            </div>
            
            <div className="progress-percentage">
              {progress.toFixed(1)}%
              {isAchieved && <span className="achievement-badge">🏆 Meta Atingida!</span>}
            </div>
          </div>
          
          <div className="next-month-budget">
            <h4>Planejamento para o Próximo Mês</h4>
            
            <div className="budget-metrics">
              <div className="budget-metric">
                <span className="metric-label">Meta para o Próximo Mês:</span>
                <span className="metric-value">R$ {nextMonthBudget.goal.toFixed(2)}</span>
              </div>
              
              <div className="budget-metric">
                <span className="metric-label">Lucro Real do Mês Atual:</span>
                <span className={`metric-value ${currentProfit >= 0 ? 'positive' : 'negative'}`}>
                  R$ {currentProfit.toFixed(2)}
                </span>
              </div>
              
              <div className="budget-metric">
                <span className="metric-label">Distribuição/Reinvestimento:</span>
                <span className="metric-value">R$ {nextMonthBudget.distribution.toFixed(2)}</span>
              </div>
              
              <div className="budget-metric">
                <span className="metric-label">Saldo para o Próximo Mês:</span>
                <span className="metric-value highlight">
                  R$ {(currentProfit - nextMonthBudget.distribution).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MonthlyGoal;